/* eslint-disable @typescript-eslint/no-unused-vars */
import { lazy } from 'react';
import { Loadable } from '../../berry/components';

const ROUTE_PREFIX = '/contacts';

const ContactRoutes = [
    {
        path: `${ROUTE_PREFIX}`,
        element: <>TODO. NO CONTACT MODULE FOR NOW</>,
        title: 'Contacts'
    }
];

export default ContactRoutes;
